// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"0e9c7669","937":"0e9c7669"}[chunkId] + ".chunk.css";
};